import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 状态聚合组件 
import kw_having_view from '@/components/look/kw_having_view.vue'; // 人员头像列表组件 

import kw_avatar from '@/components/look/kw_avatar.vue'; // 进度形式

import kw_progress from '@/components/list/kw_progress.vue'; // 倒计时

import kw_count_down from '@/components/form/kw_count_down.vue'; // 列表的按钮组件

import kw_btn_array from '@/components/look/kw_btn_array.vue';
import kw_icon from '@/components/kw/kw_icon.vue'; // 图片预览组件 kw_preview_image

import kw_preview_image from '@/components/look/kw_preview_image.vue'; //排序编辑组件

import kw_px_edit from '@/components/list/kw_px_edit.vue'; // 二维码组件

import vueQr from 'vue-qr';
import VueBarcode from "vue-barcode"; // 音频组件

import kw_audio from '@/components/form/kw_audio.vue';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_card_field',
  props: {
    fieldInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fieldIndex: {
      type: Number
    },
    dataInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dataIndex: {
      type: Number
    },
    pageSetInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isHaving: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},
  watch: {},
  computed: {},
  components: {
    kw_having_view: kw_having_view,
    kw_avatar: kw_avatar,
    kw_progress: kw_progress,
    kw_count_down: kw_count_down,
    kw_btn_array: kw_btn_array,
    kw_icon: kw_icon,
    kw_preview_image: kw_preview_image,
    kw_px_edit: kw_px_edit,
    vueQr: vueQr,
    'barcode': VueBarcode,
    kw_audio: kw_audio
  },
  methods: {
    styleSetCodeZdy: function styleSetCodeZdy(json, rowData) {
      if (json) {
        var styleSetCode = json.styleSetCode;

        if (json.zdyJs) {
          styleSetCode += eval(json.zdyJs);
        }

        return styleSetCode;
      } else {
        return "";
      }
    },
    //打开文件预览
    toPreviewFile: function toPreviewFile(dataInfo, fieldone) {
      this.$emit("toPreviewFile", dataInfo, fieldone);
    }
  }
};